module.exports = __webpack_public_path__ + "media/slow_spring_board.d7c8c9e5.mp3";